// Switcher metadata for the Omni Command shell (EDNA-2005). Extracted from
// federation-entry.ts so the shell can build its icon rail from `meta` without
// pulling the whole Growth bundle into its initial chunk — federation-entry
// re-exports this, so the entry contract is unchanged.
import type { OmniRemoteMeta } from '@omni/objects'

export const meta: OmniRemoteMeta = {
  id: 'growth',
  label: 'Growth',
  icon: 'TrendingUp',
  basePath: '/growth',
  contextCardSupport: [] as const,
}
